define([
	'jquery',
	'Handlebars'
	], function($, Handlebars) {

	'use strict';
	var DEBUG = false;

	if ( DEBUG ) console.log('data helpers');

	// limit an array to a maximum of elements (from the start)
	Handlebars.registerHelper('limit', function (arr, limit) {
		if ( !$.isArray(arr) || !arr.length ){
			return arr;
		}
		return arr.slice(0, limit);
	});

	// check if array length is greater than one
	Handlebars.registerHelper('moreThanOne', function (arr) {
		if ( !$.isArray(arr) || !arr.length ){
			return false;
		}
		if (arr.length > 1) {
			return true;
		} else {
			return false;
		}
	});

	// iterate over block for n number of times
	Handlebars.registerHelper('iterate', function(n, block) {
    	var iteration = '';
    	for(var i = 0; i < n; ++i)
        	iteration += block.fn(i);
    	return iteration;
	});

	/**
	*	custom if else statements that go beyond checking boolean
	*	usage:
	*	{{#ifEquals OPTION 'value'}} do something {{else}} do something else {{/ifEquals}}
	*/
	Handlebars.registerHelper('ifEquals', function(a, b, options) {
	  if (a === b) {
	    return options.fn(this);
	  }
	  return options.inverse(this);
	});


	/**
	 *	stringify the json content
	 *	usage:
	 *	{{{json data}}}  where the data is the json object
	 */
	Handlebars.registerHelper('json', function(context) {
		return JSON.stringify(context);
	});

	/**
	 *	Custom helper to check if string contains substring.
	 *	usage:
	 *	{{{#contains text 'subString'}}} text contains 'subString' {{else}} text does not contain 'subString' {{/contains}}
	 */
	 Handlebars.registerHelper('contains', function(v1, string, options) {
		return (v1 != undefined && v1.includes(string))? options.fn(this) : options.inverse(this);
	});

    /**
     *	Custom comparison helper that can use different operators
     *	usage:
     *	{{#ifCond var1 '>' var2}} val1 is bigger than val2 {{else}} val1 is not bigger than val2 {{/ifCond}}
     */
    Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
        switch (operator) {
            case '==':
                return (v1 == v2) ? options.fn(this) : options.inverse(this);
            case '===':
                return (v1 === v2) ? options.fn(this) : options.inverse(this);
            case '!=':
                return (v1 != v2) ? options.fn(this) : options.inverse(this);
            case '!==':
                return (v1 !== v2) ? options.fn(this) : options.inverse(this);
            case '<':
                return (v1 < v2) ? options.fn(this) : options.inverse(this);
            case '<=':
                return (v1 <= v2) ? options.fn(this) : options.inverse(this);
            case '>':
                return (v1 > v2) ? options.fn(this) : options.inverse(this);
            case '>=':
                return (v1 >= v2) ? options.fn(this) : options.inverse(this);
            case '&&':
                return (v1 && v2) ? options.fn(this) : options.inverse(this);
            case '||':
                return (v1 || v2) ? options.fn(this) : options.inverse(this);
            default:
                return options.inverse(this);
        }
	});

	/**
	 *	Custom helper to dynamically build atributes. Useful when HTML linting
     *  fails on required attributes like target="{{attrValue}}"
	 *
	 *	Usage:
	 *  Instead of: target="{{attrValue}}" (fails linting)
     *	       Use: {{{attrBuilder "target" targetValue}}}
     */
	Handlebars.registerHelper('attrBuilder', function (attrName, attrValue) {
		var attribute = "";

		if(attrName && attrName !== "" && attrValue && attrValue !== "") {
			attribute = '' + attrName + '="' + attrValue + '"';
		}

		return attribute;
	});

	/**
	 *	Custom helper to dynamically build html tags. Useful when HTML linting
     *  fails on required tags that are not properly nested due to partial inheritence
	 *
	 *	Usage:
	 *  Instead of: <li></li> (fails linting because not wrapped in <ul>)
     *	       Use: {{{tagBuilder "li"}}}
     */
	Handlebars.registerHelper('tagBuilder', function (tagName, type) {
		var tag = "";

		if(tagName && tagName !== "" && type === "start") {
			tag = '<' + tagName;
		} else if (tagName && tagName !== "" && type === "end") {
			tag = '</' + tagName + '>';
		}

		return tag;
	});


	Handlebars.registerHelper("setVar", function(varName, varValue, options) {
  		options.data.root[varName] = varValue;
	});

	/**
	* Custom helper to combine two given strings.
	*
	* Usage: {{{concat str suffix}}}
	*/
	Handlebars.registerHelper("concat", function(str, str2) {
		if (typeof str === 'string' && typeof str2 === 'string') {
			return str + str2;
		}
		return str;
	});

	/**
	* Custom helper to add attribute based on condition.
	*
	* Usage: {{{condAttr condition attribute value}}}
	*/
	Handlebars.registerHelper("condAttr", function(condition, attr, attrValue) {
		if (typeof attr === 'string' && typeof attrValue === 'string') {
			if (condition) {
				return attr + '="' + attrValue + '"';
			}
		}
	});

	/**
	* Custom helper to dynamically set an inline background image and/or background color
	* Use this helper to prevent linting errors when data is not available
	*
	* Usage: {{{setBackground imageSrc colorHex}}}
    */
	Handlebars.registerHelper("setBackground", function(color, image) {
		var style = 'style="';
		if(color && color != "") {
			style += 'background: ' + color + ';';
		}
  		if(image && image != "") {
			style += 'background-image: url(' + image + ');';
		}
		style += '"';
		return style;
	});

	Handlebars.registerHelper("setInt", function(varName, varValue, options) {
		options[varName] = parseInt(varValue,10);
	});

	Handlebars.registerHelper("math", function(varName, lvalue, operator, rvalue, options) {
		lvalue = parseFloat(lvalue);
		rvalue = parseFloat(rvalue);
		var value = {
				"+": lvalue + rvalue,
				"-": lvalue - rvalue,
				"*": lvalue * rvalue,
				"/": lvalue / rvalue,
				"%": lvalue % rvalue
		}[operator];

		options[varName] = value;
	});


	Handlebars.registerHelper("parseToInt", function(str) {
		return parseInt(str,10);
	});

	Handlebars.registerHelper("parseHtmlEntities", function(str) {
		return str.replace(/&#([0-9]{1,3});/gi, function(match, numStr) {
			var num = parseInt(numStr, 10); // read num as normal number
			return String.fromCharCode(num);
		});
	});

// begin define close
});
// end define close
